import React, { useMemo } from 'react';
import {
  ButtonGroup as MuiButtonGroup,
  ButtonGroupProps as MuiButtonGroupProps,
} from '@mui/material';

import { colorVariants } from './constants';

export interface ButtonGroupProps extends Omit<MuiButtonGroupProps, 'color' | 'variant'> {
  colorVariant?: 'tonal' | 'text';
}

export const ButtonGroup = React.forwardRef(
  (inProps: ButtonGroupProps, ref: React.RefObject<HTMLDivElement>) => {
    const { colorVariant, children, ...rest } = inProps;

    const allProps = useMemo(
      () => ({
        ...rest,
        ...colorVariants[colorVariant ?? 'tonal'],
      }),
      [colorVariant, rest],
    );

    return (
      <MuiButtonGroup {...allProps} ref={ref}>
        {children}
      </MuiButtonGroup>
    );
  },
);
